import { Controller } from "@hotwired/stimulus";

var clickOutside = require("click-outside");
import debounce from "debounce";

// Connects to data-controller="dropdown"
export default class extends Controller {
  static targets = ["content", "element"];

  connect() {
    this.elementTarget.dataset.action +=
      this.elementTarget.tagName == "INPUT"
        ? " focus->dropdown#toggle blur->dropdown#toggle"
        : " click->dropdown#toggle";

    this.element.classList.add("dropdown");
    this.contentTarget.classList.add("dropdown__content");
    this.elementTarget.classList.add("dropdown__element");

    //this.toggle = debounce(this.toggle, 10);
  }

  toggle(e) {
    if (this.timeout) clearTimeout(this.timeout);

    this.timeout = setTimeout(
      () => {
        let state;

        if (this.elementTarget.tagName == "INPUT")
          state = this.element.classList.toggle(
            "dropdown--active",
            e.type == "focus"
          );
        else state = this.element.classList.toggle("dropdown--active");

        if (state) {
          let bounds = 300;

          let elementRect = this.element.getBoundingClientRect();

          console.log(elementRect.y + bounds, window.innerHeight);

          this.element.classList.toggle(
            "dropdown--y",
            elementRect.y + bounds > window.innerHeight
          );
          this.element.classList.toggle(
            "dropdown--x",
            elementRect.x + bounds > window.innerWidth
          );

          this.eventListener = clickOutside(this.element, (e) => {
            this.close();

            this.eventListener();
          });
        }
      },
      e.type == "blur" ? 500 : 0
    );
  }

  close() {
    this.element.classList.remove("dropdown--active");
  }
}
